if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", (event) => this.onVariantChange(event));
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();

        // Only use old variant status logic for regular products (no option value IDs)
        const hasOptionValueIds = this.querySelector('input[data-option-value-id]');
        if (!hasOptionValueIds) {
          this.updateVariantStatuses();
        }

        this.updateDropdownButtons();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange(event) {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);

        // Handle combined listings only if product URL changes
        if (event && event.target && event.target.dataset.productUrl) {
          const productElement = event.target.closest(`section[data-product-handle]`);
          const currentProductUrl = productElement?.dataset.productUrl || this.dataset.url;
          const newProductUrl = event.target.dataset.productUrl;

          // Only use combined listings logic if the product URL is actually different
          if (newProductUrl && currentProductUrl !== newProductUrl) {
            this.handleCombinedListings(event);
            return;
          }
        }

        // Handle section rendering for option availability updates
        if (event && event.target) {
          this.updateOptionAvailability(event);
        }

        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        // Only use old variant status logic for regular products (no option value IDs)
        const hasOptionValueIds = this.querySelector('input[data-option-value-id]');
        if (!hasOptionValueIds) {
          this.updateVariantStatuses();
        }

        this.updateDropdownButtons();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      handleCombinedListings(event) {
        const productElement = event.target.closest(`section[data-product-handle]`);
        const sectionId = this.dataset.section;

        // Get current and new product URLs for combined listings detection
        const oldProductUrl = productElement?.dataset.productUrl || this.dataset.url;
        const newProductUrl = event.target.dataset.productUrl;

        this.fetchProductSection(newProductUrl, sectionId, '')
          .then((html) => {
            const newVariantOptions = html.querySelector('variant-options');
            if (newVariantOptions) {
              // Preserve the current selection and update only availability
              const currentSelectedValues = Array.from(
                this.querySelectorAll('input[type="radio"]:checked')
              ).map(input => input.id);

              this.innerHTML = newVariantOptions.innerHTML;

              // Restore selections
              currentSelectedValues.forEach(inputId => {
                const input = this.querySelector(`#${inputId}`);
                if (input) input.checked = true;
              });

              this.updateGallery(html);
              // Re-initialize to update options display
              this.updateOptions();
              this.updateDropdownButtons();

            }

            // Update this.variantData
            this.getVariantDataForCombinedListings();
            // Update the value of the product form input based on this.currentVariant
            this.updateMasterIdForCombinedListings();

            // We only replaced the inner HTML previously - now we update the data attributes of the "outer" HTML
            // this.setAttribute('data-product-handle', html.dataset.productHandle);
            this.setAttribute('data-product-handle', newVariantOptions.dataset.productHandle);
            this.setAttribute('data-url', newVariantOptions.dataset.url);

            // Default Theme logic
            if (!this.currentVariant) {
              this.toggleAddButton(true, "", true);
              this.setUnavailable();
            } else {
              this.updateMedia();
              this.lenOfVariantOptions =
                document.querySelectorAll("variant-options").length;
              if (this.lenOfVariantOptions === 1) {
                this.updateURL();
              }
              // Will change the ID for the product form input value based on the current variant
              this.updateVariantInput();
              // Updates the product attributes (Price, SKU, etc.)
              this.renderProductInfo();
              this.updateShareUrl(); 
            }
          });
      }

    // PXL-892: Create custom function to load a specific section
      async fetchProductSection(fetchUrl, sectionId, params) {
        return fetch(`${fetchUrl}?section_id=${sectionId}${params}`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            return html;
          });
      }

    updateOptionAvailability(event) {
        // Only update availability if we have option value IDs (high-variant products)
        const selectedOptionValues = Array.from(
          this.querySelectorAll('input[type="radio"]:checked')
        ).map(input => input.dataset.optionValueId).filter(Boolean);

        // If no option value IDs, skip section rendering (regular products)
        if (selectedOptionValues.length === 0) {
          return;
        }

        const sectionId = this.dataset.section;
        const params = `&option_values=${selectedOptionValues.join(',')}`;

        // Fetch updated availability state
        fetch(`${this.dataset.url}?section_id=${sectionId}${params}`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const newVariantOptions = html.querySelector('variant-options');
            if (newVariantOptions) {
                // Preserve the current selection and update only availability
              const currentSelectedValues = Array.from(
                this.querySelectorAll('input[type="radio"]:checked')
              ).map(input => input.id);

              this.innerHTML = newVariantOptions.innerHTML;

              // Restore selections
              currentSelectedValues.forEach(inputId => {
                const input = this.querySelector(`#${inputId}`);
                if (input) input.checked = true;
              });

              this.updateGallery(html);
              // Re-initialize to update options display
            this.updateOptions();
            this.updateDropdownButtons();
          }
          })
          .catch(error => {
            console.error('Error updating option availability:', error);
          });
      }

      updateGallery(html) {
        const currentGallery = document.getElementById(
            `MediaGallery-${this.dataset.section}`,
          );

        if (html) {
          // Replace Media-Gallery HTML and initilize it again
          const newGallery = html.getElementById(`MediaGallery-${this.dataset.section}`);
          if (currentGallery && newGallery) {
            currentGallery.innerHTML = newGallery.innerHTML;

            if (typeof currentGallery.readConfiguration === 'function') {
              currentGallery.destroyCarouselGallery();
              currentGallery.readConfiguration();
              currentGallery.initializeGallery();
            }
          }
        } else {
          // Default behavior
          let media_id = false;
          if (this.currentVariant && this.currentVariant.featured_media) {
            media_id = this.currentVariant.featured_media.id;
          }

          currentGallery?.filterSlides(this.options, media_id, true);
        }
      }

      updateDropdownButtons(){
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || '';
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if(!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];

          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      /**
       * Every product in a combined listing will always have only a single variant.
       * Therefore, we can directly set the current variant to the first variant in the variantData list.
       */
      updateMasterIdForCombinedListings() {
        this.currentVariant = this.variantData?.[0];
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateSku() {
        const skuElement = document.getElementById(`Sku-${this.dataset.section}`);
        if (!skuElement) return;

        if (this.currentVariant && this.currentVariant.sku) {
          // Show the SKU element and update its content with just the SKU value
          skuElement.style.display = '';
          skuElement.textContent = this.currentVariant.sku;
        } else {
          // Hide the SKU element if no SKU available
          skuElement.style.display = 'none';
        }
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            const titleSource = html.getElementById(
              `title-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const titleDestination = document.getElementById(
              `title-${this.dataset.section}`,
            );

            // Multiple blocks of type "Description" may exist on the page, so we cannot rely on the dynamic ID here.
            // Using the querySelector, we retrieve the first match and update it.
            const descriptionSource = html.querySelector('[id^="Description-"]');
            const descriptionDestination = document.querySelector('[id^="Description-"]');

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }
            if (titleSource && titleDestination)
              titleDestination.innerHTML = titleSource.innerHTML;
            if (descriptionSource && descriptionDestination)
              descriptionDestination.innerHTML = descriptionSource.innerHTML;

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            const addButtonUpdated = html.getElementById(
              `ProductSubmitButton-${sectionId}`,
            );
            this.toggleAddButton(
              addButtonUpdated
                ? addButtonUpdated.hasAttribute("disabled")
                : true,
              window.variantStrings.soldOut,
            );

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html,
                variant:this.currentVariant
              },
            });
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );

        return this.variantData;
      }

      /**
       * If a product is a combined listing, always parse the variant data.
       * For normal products, it's fine to use the existing logic.
       */
      getVariantDataForCombinedListings() {
        this.variantData =
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);
